var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { decodeSystemFirmwareUpgradeResponse } from '../../../../types/lighthouse/decoders/system/firmware-upgrade';
import { SYSTEM_FIRMWARE_UPGRADE_STATUS_PATH } from '@/api/system/firmware-upgrade-status/firmware-upgrade-status';
import { useLighthouseFetch } from '@/hooks/use-lighthouse-fetch';
export var SYSTEM_FIRMWARE_UPGRADE_PATH = '/system/firmware_upgrade';
export function useFirmwareUpgrade() {
    var _this = this;
    var t = useTranslation().t;
    var _a = useLighthouseFetch(), executeFetch = _a.executeFetch, decodeResponse = _a.decodeResponse, handleCommonStatusCodes = _a.handleCommonStatusCodes;
    var queryClient = useQueryClient();
    return useCallback(function (firmwareUpgrade) { return __awaiter(_this, void 0, void 0, function () {
        var formData, response, _a, data, status;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    formData = new FormData();
                    if (firmwareUpgrade.file)
                        formData.append('file', firmwareUpgrade.file);
                    if (firmwareUpgrade.firmware_url)
                        formData.append('firmware_url', firmwareUpgrade.firmware_url);
                    if (firmwareUpgrade.firmware_options)
                        formData.append('firmware_options', firmwareUpgrade.firmware_options);
                    return [4 /*yield*/, executeFetch(SYSTEM_FIRMWARE_UPGRADE_PATH, {
                            method: 'POST',
                            body: formData,
                            headers: new Headers({ Accept: 'application/json' }),
                        })];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, decodeResponse(decodeSystemFirmwareUpgradeResponse, response)];
                case 2:
                    _a = _b.sent(), data = _a.data, status = _a.status;
                    handleCommonStatusCodes(data, status, t('api.system_firmware_upgrade.post'));
                    if (status === 200) {
                        queryClient.setQueryData([SYSTEM_FIRMWARE_UPGRADE_STATUS_PATH], { system_firmware_upgrade_status: { state: 'running' } });
                        return [2 /*return*/, data];
                    }
                    return [2 /*return*/, null];
            }
        });
    }); }, [decodeResponse, executeFetch, handleCommonStatusCodes, queryClient, t]);
}
